<div class="card-panel" [ngClass]="customHeaderPanel ? customHeaderPanel : ''">
  <!--CARD HEADER-->
  <!--Use or override with custom css based on card type-->
  <div class="card-header" [ngClass]="customHeaderCss ? customHeaderCss : ''">
    <!--CARD ICON-->
    <ng-container *ngIf="showTooltip && informationTooltip !== ''; else showIcon">
      <app-information-tooltip
        [tooltipData]="informationTooltip"
        [tooltipIcon]="'info-icon'"
        [iconSize]="'small'"
        [tooltipClass]="'card-icon'"
        [iconColor]="'white'"></app-information-tooltip>
    </ng-container>
    <ng-template #showIcon>
      <span class="card-icon icon" [ngClass]="icon ? icon : ''"></span>
    </ng-template>
    <!--CARD HEADING & SUBHEADING-->
    <div class="card-heading" [ngClass]="customHeadingGroupCss ? customHeadingGroupCss : ''">
      <!--CARD TYPE-->
      <ng-container *ngIf="cardType !== cardTypeName.FLEXIBLE_METHODS_OF_LEARNING">
        <span class="card-course-category" [innerHTML]="cardType"></span>
      </ng-container>
      <!--END CARD TYPE-->
      <!--NOTE: Else show everything else as a course-->
      <ng-container
        *ngIf="
          cardType === cardTypeSlugs.LEARNING_PLAN ||
          cardType === cardTypeSlugs.SUBSCRIPTION ||
          cardType === cardTypeSlugs.FLEXIBLE_METHODS_OF_LEARNING ||
          cardType === cardTypeSlugs.UPCOMING_SESSION
        ">
        <p [ngClass]="customHeaderTitleCss ? customHeaderTitleCss : ''">
          <a
            id="card-header-link-{{ buttonRoute }}"
            attr.data-beyond-link-id="card-header-link-{{ buttonRoute }}"
            *ngIf="route && cardType !== cardTypeSlugs.UPCOMING_SESSION; else noRoutingTitle"
            class="gen-neutral-link-on-primary bold"
            routerLink="/{{ route }}"
            [title]="title">
            {{ title | decodeEntities | truncate : 160 }}
          </a>
        </p>
        <ng-template #noRoutingTitle>
          <span [innerHTML]="title | truncate : 160"></span>
        </ng-template>
      </ng-container>
      <!--NOTE: Show SubTitles (ex. Free courses)-->
      <ng-container *ngIf="showSubTitle">
        <p [innerHTML]="showSubTitle"></p>
      </ng-container>
    </div>
    <!--END CARD HEADING & SUBHEADING-->
  </div>
  <!--END CARD HEADER-->
  <!--CARD BODY-->
  <div class="card-body" [ngClass]="customCardHeightCss ? customCardHeightCss : ''">
    <div class="card-description">
      <!--NOTE: For Non-Subscription Card Types, show the CardType in the card body-->
      <ng-container
        *ngIf="cardType !== cardTypeSlugs.LEARNING_PLAN && cardType !== cardTypeSlugs.SUBSCRIPTION">
        <span
          class="card-course-category"
          [innerHTML]="cardSubType"
          (click)="onClick('link')"></span>
      </ng-container>
      <!--NOTE: If there is a route link, show it. Else hide route and show description-->

      <!--NOTE: For Courses show title and link within the card body-->
      <ng-container
        *ngIf="
          cardType !== cardTypeSlugs.LEARNING_PLAN &&
          cardType !== cardTypeSlugs.SUBSCRIPTION &&
          cardType !== cardTypeSlugs.FLEXIBLE_METHODS_OF_LEARNING &&
          cardType !== cardTypeSlugs.UPCOMING_SESSION
        ">
        <p [ngClass]="customHeaderTitleCss ? customHeaderTitleCss : ''">
          <a
            id="card-body-link-{{ buttonRoute }}"
            attr.data-beyond-link-id="card-body-link-{{ buttonRoute }}"
            *ngIf="route; else noRoutingTitle"
            class="bold gen-neutral-black-link"
            routerLink="/{{ route }}"
            [state]="queryParams"
            title="{{ title }}">
            {{ title | truncate : 160 }} <span *ngIf="title.length > 160">&hellip;</span>
          </a>
        </p>
        <ng-template #noRoutingTitle>
          <span (click)="onClick('link')" [innerHTML]="title | truncate : 160"></span>
        </ng-template>
      </ng-container>

      <!--CARD DESCRIPTION BODY-->
      <div
        *ngIf="cardType !== cardTypeSlugs.UPCOMING_SESSION; then thenBlock; else elseBlock"></div>

      <ng-template #thenBlock>
        <div class="card-details" *ngIf="route; else noRoute">
          <p>
            <span [innerHTML]="description | decodeEntities | truncate : 190"></span>&nbsp;
            <a
              class="gen-neutral-black-link"
              routerLink="/{{ route }}"
              title="View Details - {{ title }}">
              [&hellip;]
            </a>
          </p>
        </div>
        <ng-template #noRoute>
          <ng-container
            *ngIf="cardType === cardTypeName.FLEXIBLE_METHODS_OF_LEARNING; else elseBlock">
            <p (click)="onClick('link')" [innerHTML]="description | safe : 'html'"></p>
          </ng-container>
          <ng-template #elseBlock>
            <p>
              <span
                (click)="onClick('link')"
                [innerHTML]="description | decodeEntities | truncate : 190"></span>
            </p>
          </ng-template>
        </ng-template>
      </ng-template>

      <ng-template #elseBlock>
        <div class="card-details">
          <!--DELIVERY METHOD-->
          <ng-container *ngIf="sessionDescription.sessionDeliveryType">
            <div class="flexbox align-items-center">
              <h5 class="bold">Delivery Method: &nbsp;</h5>
              <div class="lighter">{{ sessionDescription.sessionDeliveryType }}</div>
            </div>
          </ng-container>
          <!--END DELIVERY METHOD-->

          <!--LOCATION INFORMATION-->
          <ng-container
            *ngIf="sessionDescription?.locations && sessionDescription?.locations.length > 0">
            <div>
              <h5 class="bold">Location:</h5>
              <p>
                {{ sessionDescription.locations[0].name }}<br />
                {{ sessionDescription.locations[0].address }}
              </p>
            </div>
          </ng-container>
          <!--END LOCATION INFORMATION-->

          <ng-container *ngIf="sessionDescription.dates && sessionDescription.dates.length > 0">
            <!--SESSION DATES-->
            <div class="margin-bottom-small">
              <h5 class="bold">Session Dates:</h5>
              <p>
                {{ sessionDescription.startDate | utcDateFormat | date }} -
                {{ sessionDescription.endDate | utcDateFormat | date }}<br />
                {{
                  sessionDescription.dates[0].date + ' ' + sessionDescription.dates[0].startHour
                    | utcDateFormat
                    | date : 'shortTime'
                }}
                -
                {{
                  sessionDescription.dates[0].date + ' ' + sessionDescription.dates[0].endHour
                    | utcDateFormat
                    | date : 'shortTime'
                }}
                {{ sessionDescription?.dates[0]?.utcOffset }} <br />
                {{ sessionDescription?.dates[0]?.timezone }}
              </p>
            </div>
          </ng-container>
          <!--END SESSION DATES-->
        </div>
      </ng-template>
      <!--END CARD DESCRIPTION BODY-->
    </div>
    <div class="card-actions" *ngIf="showButton">
      <!--ROUTE BUTTON-->
      <app-route-button
        [id]="buttonRoute"
        [disabled]="disabled"
        [route]="route"
        [secondaryLinkRoute]="secondaryLinkRoute"
        [routeType]="routeType"
        [buttonRoute]="buttonRoute"
        [mailToDetails]="mailToDetails"
        (buttonClick)="onClick($event)"
        (secondaryButtonClick)="secondaryOnClick($event)"
        [actionLabel]="actionLabel"
        [secondaryActionLabel]="secondaryActionLabel"
        [showSecondaryButton]="showSecondaryButton"
        [customButtonCss]="customButtonCss">
      </app-route-button>
      <!--END ROUTE BUTTON-->
      <!--DURATION-->
      <app-duration
        [showDuration]="instructionType | showDurationByInstructionType"
        [duration]="courseDuration"
        [showIcon]="false"
        [ngClass]="['margin-left-auto', 'even-smaller-text']">
      </app-duration>
      <!--END DURATION-->
    </div>
  </div>
  <!--ERROR MESSAGE-->
  <ng-container *ngIf="showErrorMessage && errorMessage">
    <div class="error-message">{{ errorMessage }}</div>
  </ng-container>
  <!--ERROR MESSAGE-->
  <!--END CARD BODY-->
</div>
